import { C } from "../../shared/theme";
import { DoneCheck } from "./DoneCheck";

// Finished tasks under a list's task cards, on a Key Date card and a goal's page: struck through, their ticked circle
// lines up with the cards' circles and unticks with a tap (the task goes back to do), and the words open the task.
// onUndo(task) saves and returns a promise; onOpen(task) opens it.
export function DoneTaskList({ tasks, onUndo, onOpen }) {
  return (
    <ul aria-label="Done" style={{ listStyle: "none", margin: 0, padding: "0 0 0 11px" }}>
      {tasks.map(task => (
        <li key={task.id} style={{ display: "flex", alignItems: "center" }}>
          <DoneCheck text={task.text} done onUndo={() => onUndo(task)} />
          <button onClick={() => onOpen(task)}
            style={{ flex: 1, minWidth: 0, minHeight: 44, padding: "10px 4px 10px 2px", background: "none", border: "none", textAlign: "left", cursor: "pointer", fontFamily: "inherit", fontSize: 15, lineHeight: 1.35, color: C.textMid, textDecoration: "line-through" }}>
            {task.text}
          </button>
        </li>
      ))}
    </ul>
  );
}
